export default __webpack_public_path__ + "static/media/what-we-offers-bg-1.9f4241a6.jpg";